import mutations, { getDefaultState } from './mutations'
import actions from './actions'

export const programacao = {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions
}
